/**
 * Asset manifest: files under public/assets/, loaded by the preload scene. Add new files to
 * BOTH the folder and this manifest (tests/unit/game/game.test.ts checks every entry exists).
 */
export const IMAGES = {
	/** LEGO 21351, 1200×958, transparent around the set (src/sim/spots.ts is measured on it). */
	backdrop: "gfx/backdrop.png",
} as const satisfies Record<string, string>;
/** Generated by scripts/generate-sounds.mjs (`pnpm sounds`). */
export const SOUNDS = {
	pling: "sfx/pling.wav",
	golden: "sfx/golden.wav",
	on: "sfx/on.wav",
	count: "sfx/count.wav",
	go: "sfx/go.wav",
	tick: "sfx/tick.wav",
	end: "sfx/end.wav",
	miss: "sfx/miss.wav",
	bat: "sfx/bat.wav",
	ghost: "sfx/ghost.wav",
	trick: "sfx/trick.wav",
	streak: "sfx/streak.wav",
} as const satisfies Record<string, string>;
